import { KypayInstrumentIcon } from "@/atoms-react/crypto-icon/KypayInstrumentIcon.react";
import { Base } from "@/atoms-react/text/Text.react";
import { isSystemThemeDark } from "@/features/utils/theme";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export const PartnerCardHeader = () => {
  const { t } = useTranslation(["pass"]);
  const [isDark, setIsDark] = useState<boolean>(false);

  useEffect(() => {
    const prefersDark = isSystemThemeDark();

    if (prefersDark) {
      setIsDark(true);
    }
  }, []);
  return (
    <div className="hidden justify-between lg:flex lg:flex-row">
      <Base className="w-1/4 font-semibold text-xl 2xl:text-2xl">
        {" "}
        {t("olkypass.mainPage.olkypass.dashbord.title_partner")}
      </Base>

      <div className="flex w-1/2 flex-row">
        <Base className="font-semibold text-md lg:text-lg">
          {t("olkypass.mainPage.olkypass.dashbord.title_sub_account")}
        </Base>
        <KypayInstrumentIcon
          isDark={isDark}
          className="ml-2 flex w-10 flex-col justify-center lg:w-14"
        />
      </div>

      <Base className="w-1/4 font-semibold text-md lg:text-lg">Token</Base>
    </div>
  );
};
